import { useTrackersData } from 'pages/Trackers/trackersProvider';
import PropTypes from 'prop-types';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { stepType } from 'utils/reactFlowUtils';

import CollapsedFlowchartView from './collapsedFlowchartView';
import CollapsedListView from './collapsedListView';
import ExpandedView from './expandedView';
import ProjectHeader from './projectHeader';

export default function ProjectContainer({
  projectId,
  orgId,
  treesData,
}) {
  const { collapsedView } = useTrackersData();
  const [expanded, setExpanded] = useState(false);
  const expandedView = useRef({
    ref: undefined,
    nodeToFocus: undefined,
  });
  const root = useMemo(() => treesData[0]?.[0]?.[0], [treesData]);
  // expansion/collapse logic
  const toggleView = useCallback((uniqueId = null) => {
    setExpanded((prev) => {
      expandedView.current.nodeToFocus = prev
        ? undefined
        : uniqueId || root.uniqueId;
      return !prev;
    });
  }, [root?.uniqueId]);

  useEffect(() => {
    const expandedViewRef = expandedView.current.ref;
    if (!expandedViewRef || !expandedView.current.nodeToFocus) return;
    const nodeToFocus = expandedViewRef.querySelector(`#${expandedView.current.nodeToFocus}`);
    nodeToFocus?.focus();
  }, [expanded]);

  return (
    <li className={`tracker-project${expanded ? ' expanded' : ''}`}>
      <ProjectHeader
        expanded={expanded}
        toggleView={() => toggleView()}
        projectId={projectId}
        orgId={orgId}
      />
      {expanded && (
        <ExpandedView
          ref={(ref) => { expandedView.current.ref = ref; }}
          treesData={treesData}
          root={root}
          collapse={toggleView}
        />
      )}
      {!expanded && (collapsedView === 'list'
        ? (
          <CollapsedListView
            projectId={projectId}
            treesData={treesData}
            expandTo={toggleView}
          />
        ) : (
          <CollapsedFlowchartView
            treesData={treesData}
            root={root}
            expandTo={toggleView}
          />
        )
      )}
    </li>
  );
}

ProjectContainer.propTypes = {
  projectId: PropTypes.string.isRequired,
  orgId: PropTypes.string.isRequired,
  treesData: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.arrayOf(stepType),
    ),
  ).isRequired,
};
